<div
  class="pv3-content-list-menu"
  [ngClass]="wrapperKlasses()"
  #hScrollContainer
>
  @if (_menuItemTemplate) {
    @for (item of contentMenuItems(); track item.id) {
      <ng-container
        [ngTemplateOutlet]="_menuItemTemplate"
        [ngTemplateOutletContext]="{ menuItem: item }"
      ></ng-container>
    }
  } @else {
    <div class="text-red-500 text-xl text-center mt-4 mb-4">
      No menuItemTemplate provided!
    </div>
  }
</div>
